import React from "react";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { useStoreSettings } from "../hooks/useHomeContent";
import { trackWhatsApp } from "../lib/track";

export default function Contact() {
  const store = useStoreSettings();
  return (
    <section className="contact" id="contact">
      <div className="wrap">
        <span className="eyebrow reveal">Visit &amp; Contact</span>
        <h2 className="reveal">We'd love to show you around.</h2>
        <div className="contact-grid">
          <div className="contact-cards reveal">
            <div className="ccard">
              <Phone strokeWidth={1.5} />
              <h4>Call Us</h4>
              <a href={store.telHref} data-testid="contact-phone">
                {store.phone}
              </a>
            </div>
            <div className="ccard">
              <Mail strokeWidth={1.5} />
              <h4>Email Us</h4>
              <a href={store.mailHref} data-testid="contact-email">
                {store.email}
              </a>
            </div>
            <div className="ccard">
              <MapPin strokeWidth={1.5} />
              <h4>Visit the Store</h4>
              <p data-testid="contact-address">
                {store.addressLine1}
                <br />
                {store.addressLine2}
              </p>
            </div>
            <div className="ccard">
              <MessageCircle strokeWidth={1.5} />
              <h4>WhatsApp Us</h4>
              <a
                target="_top"
                rel="noreferrer"
                href={store.waGeneric}
                data-testid="contact-whatsapp"
                onClick={() => trackWhatsApp({ source: "contact" })}
              >
                Chat Instantly →
              </a>
            </div>
          </div>
          <div className="map-wrap reveal">
            <iframe
              title="Alankar Jewellers Store Location"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src={store.mapEmbedUrl}
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
